/* AFERIY Media Gallery - separate Photos / Videos / Lifestyle / 3D tracks.
   Designed for sections/Newproduct-page.liquid. No external slider dependency. */
(function () {
  'use strict';
  const roots = Array.from(document.querySelectorAll('.af-product-gallery[data-af-gallery]'));

  function setupGallery(root) {
    if (root.__afGallery) return;
    const sectionId = root.dataset.afGallery;
    const modal = document.getElementById('af-zoom-' + sectionId);
    const zoomBody = modal?.querySelector('[data-gallery-zoom-body]');
    const panelNodes = Array.from(root.querySelectorAll('[data-gallery-stage]'));
    const panels = new Map();
    const positions = new Map();
    let active = null;
    let previousFocus = null;

    panelNodes.forEach(panel => {
      const type = panel.dataset.galleryStage;
      const track = panel.querySelector('[data-gallery-track]');
      const slides = Array.from(track?.querySelectorAll('.media-slide') || []);
      const dots = root.querySelector('[data-gallery-dots="' + type + '"]');
      const tab = root.querySelector('[data-gallery-switch="' + type + '"]');
      if (!track || !slides.length) {
        if (tab) tab.hidden = true;
        panel.hidden = true;
        if (dots) dots.hidden = true;
        return;
      }
      panels.set(type, { panel, track, slides, dots, tab });
      positions.set(type, 0);
      const fragment = document.createDocumentFragment();
      slides.forEach((slide, index) => {
        const thumb = document.createElement('button');
        thumb.type = 'button';
        thumb.className = 'nav-item';
        thumb.dataset.galleryThumb = String(index);
        thumb.dataset.galleryType = type;
        thumb.setAttribute('aria-label', type + ' ' + (index + 1) + ' of ' + slides.length);
        const preview = slide.dataset.thumb || slide.querySelector('img')?.currentSrc || slide.querySelector('img')?.src || slide.querySelector('video')?.poster;
        if (preview) {
          const image = document.createElement('img');
          image.src = preview;
          image.alt = '';
          image.loading = 'lazy';
          thumb.appendChild(image);
        } else {
          const symbol = document.createElement('span');
          symbol.textContent = type === 'videos' ? '\u25b6' : type === '3d' ? '3D' : '\u25cb';
          thumb.appendChild(symbol);
        }
        fragment.appendChild(thumb);
      });
      dots?.appendChild(fragment);
      panel.querySelectorAll('[data-gallery-nav]').forEach(button => { button.hidden = slides.length <= 1; });
    });
    if (!panels.size) return;

    function normalize(type, index) {
      const count = panels.get(type).slides.length;
      const number = Math.trunc(Number(index) || 0);
      return ((number % count) + count) % count;
    }

    function pauseMedia(mediaRoot) {
      if (!mediaRoot) return;
      mediaRoot.querySelectorAll('video').forEach(video => {
        try { video.pause(); } catch (error) { /* Unloaded player */ }
      });
      mediaRoot.querySelectorAll('iframe').forEach(frame => {
        if (frame.dataset.afGallerySeen !== '1') return;
        try {
          const src = frame.getAttribute('src') || '';
          if (src.includes('youtube') || src.includes('youtu.be')) {
            frame.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), 'https://www.youtube.com');
          } else if (src.includes('vimeo')) {
            frame.contentWindow?.postMessage(JSON.stringify({ method: 'pause' }), 'https://player.vimeo.com');
          }
          // Reload the iframe to stop playback even when external JS player APIs are disabled.
          if (src) frame.setAttribute('src', src);
          frame.dataset.afGallerySeen = '0';
        } catch (error) { /* Cross-origin player / detached frame */ }
      });
    }

    function pauseOutsideCurrent() {
      panels.forEach((group, type) => {
        group.slides.forEach((slide, index) => {
          if (type !== active || index !== positions.get(type)) pauseMedia(slide);
        });
      });
    }

    function updateThumbs(type) {
      const group = panels.get(type);
      if (!group?.dots) return;
      const index = positions.get(type);
      const buttons = Array.from(group.dots.querySelectorAll('[data-gallery-thumb]'));
      buttons.forEach((button, i) => {
        button.classList.toggle('active', i === index);
        button.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      const activeThumb = buttons[index];
      if (activeThumb && !group.dots.hidden) {
        const left = activeThumb.offsetLeft - group.dots.offsetLeft + activeThumb.offsetWidth / 2 - group.dots.clientWidth / 2;
        group.dots.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    }

    function goTo(type, index, options) {
      const group = panels.get(type);
      if (!group) return;
      if (active !== type) show(type);
      const previous = positions.get(type);
      const current = normalize(type, index);
      if (previous !== current) pauseMedia(group.slides[previous]);
      positions.set(type, current);
      group.track.style.transform = 'translate3d(calc(-' + current * 100 + '% - ' + current * 20 + 'px),0,0)';
      group.slides[current]?.querySelectorAll('iframe').forEach(frame => { frame.dataset.afGallerySeen = '1'; });
      updateThumbs(type);
      pauseOutsideCurrent();
      const model = type === '3d' ? group.slides[current]?.querySelector('model-viewer') : null;
      if (model && typeof model.requestUpdate === 'function') model.requestUpdate();
      if (options?.focusThumb && group.dots) {
        group.dots.querySelectorAll('[data-gallery-thumb]')[current]?.focus({ preventScroll: true });
      }
    }

    function show(type) {
      if (!panels.has(type)) return;
      if (active && active !== type) pauseMedia(panels.get(active).panel);
      active = type;
      panels.forEach((group, key) => {
        const selected = key === type;
        group.panel.hidden = !selected;
        group.panel.classList.toggle('active', selected);
        if (group.dots) group.dots.hidden = !selected;
        if (group.tab) {
          group.tab.classList.toggle('active', selected);
          group.tab.setAttribute('aria-selected', String(selected));
        }
      });
      goToCurrent(type);
    }

    function goToCurrent(type) {
      const group = panels.get(type);
      const index = positions.get(type);
      if (!group) return;
      group.track.style.transform = 'translate3d(calc(-' + index * 100 + '% - ' + index * 20 + 'px),0,0)';
      group.slides[index]?.querySelectorAll('iframe').forEach(frame => { frame.dataset.afGallerySeen = '1'; });
      updateThumbs(type);
      pauseOutsideCurrent();
    }

    function openZoom() {
      if (!modal || !zoomBody || !active || active === '3d') return;
      const group = panels.get(active);
      const slide = group?.slides[positions.get(active)];
      if (!slide) return;
      const item = slide.querySelector('img, video, iframe');
      if (!item) return;
      pauseMedia(slide);
      zoomBody.replaceChildren();
      let enlarged;
      if (item.matches('img')) {
        enlarged = document.createElement('img');
        enlarged.src = item.currentSrc || item.src;
        enlarged.alt = item.alt || '';
      } else if (item.matches('video')) {
        enlarged = item.cloneNode(true);
        enlarged.controls = true;
        enlarged.autoplay = false;
        enlarged.muted = false;
        enlarged.removeAttribute('autoplay');
      } else {
        enlarged = item.cloneNode(true);
      }
      zoomBody.appendChild(enlarged);
      previousFocus = document.activeElement;
      modal.hidden = false;
      modal.classList.add('active');
      modal.querySelector('[data-gallery-close]')?.focus();
    }

    function closeZoom() {
      if (!modal) return;
      pauseMedia(zoomBody);
      modal.classList.remove('active');
      modal.hidden = true;
      zoomBody?.replaceChildren();
      if (previousFocus && document.contains(previousFocus)) previousFocus.focus({ preventScroll: true });
      previousFocus = null;
    }

    root.addEventListener('click', event => {
      const tab = event.target.closest('[data-gallery-switch]');
      if (tab && root.contains(tab)) { show(tab.dataset.gallerySwitch); return; }
      const arrow = event.target.closest('[data-gallery-nav]');
      if (arrow && root.contains(arrow)) {
        const type = arrow.closest('[data-gallery-stage]')?.dataset.galleryStage;
        if (type && panels.has(type)) goTo(type, positions.get(type) + Number(arrow.dataset.galleryNav));
        return;
      }
      const thumb = event.target.closest('[data-gallery-thumb]');
      if (thumb && root.contains(thumb)) { goTo(thumb.dataset.galleryType, Number(thumb.dataset.galleryThumb)); return; }
      const zoom = event.target.closest('[data-gallery-zoom]');
      if (zoom && root.contains(zoom)) openZoom();
    });

    modal?.addEventListener('click', event => {
      if (event.target === modal || event.target.closest('[data-gallery-close]')) closeZoom();
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !modal?.hidden) { closeZoom(); return; }
      if (!root.contains(document.activeElement) || !active) return;
      if (document.activeElement?.closest('video,iframe,model-viewer')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(active, positions.get(active) + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });

    panels.forEach((group, type) => {
      let dragStart = null;
      group.panel.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (type === '3d' || event.target.closest('button,video,iframe,model-viewer')) return;
        dragStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
      });
      group.panel.addEventListener('pointerup', event => {
        if (!dragStart || dragStart.id !== event.pointerId) return;
        const deltaX = event.clientX - dragStart.x;
        const deltaY = event.clientY - dragStart.y;
        dragStart = null;
        if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) {
          goTo(type, positions.get(type) + (deltaX < 0 ? 1 : -1));
        }
      });
      group.panel.addEventListener('pointercancel', () => { dragStart = null; });
    });

    root.addEventListener('af:variant-media', event => {
      if (!panels.has('photos')) return;
      const index = Number(event.detail?.index);
      if (!Number.isInteger(index) || index < 0 || index >= panels.get('photos').slides.length) return;
      show('photos');
      goTo('photos', index);
    });

    let resizeFrame = 0;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(() => {
        panels.forEach((group, type) => {
          const index = positions.get(type);
          const oldTransition = group.track.style.transition;
          group.track.style.transition = 'none';
          group.track.style.transform = 'translate3d(calc(-' + index * 100 + '% - ' + index * 20 + 'px),0,0)';
          requestAnimationFrame(() => { group.track.style.transition = oldTransition; });
        });
      });
    });

    function openZoomForMedia(mediaId) {
      const group = panels.get('photos');
      if (!group || mediaId == null) return false;
      const index = group.slides.findIndex(slide => String(slide.dataset.mediaId) === String(mediaId));
      if (index < 0) return false;
      show('photos');
      goTo('photos', index);
      requestAnimationFrame(() => openZoom());
      return true;
    }

    // Only gallery-scoped methods are the source of truth; other tabs retain their positions.
    root.__afGallery = { show, goTo, openZoom, closeZoom, openZoomForMedia, positions };
    const first = panels.has('photos') ? 'photos' : panels.keys().next().value;
    show(first);
  }

  roots.forEach(setupGallery);

  // Variant image overlays select their option, switch the Photos track, then reuse the same zoom modal.
  function zoomFromVariantImage(trigger) {
    const radioId = trigger.dataset.optionRadioId;
    const radio = radioId ? document.getElementById(radioId) : null;
    if (radio?.disabled) return;
    const clickedMediaId = trigger.dataset.mediaId;
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const section = trigger.closest('.product-details');
    const galleryRoot = section?.querySelector('.af-product-gallery[data-af-gallery]') || document.querySelector('.af-product-gallery[data-af-gallery]');
    if (!galleryRoot?.__afGallery || clickedMediaId == null) return;
    requestAnimationFrame(() => {
      const mediaId = trigger.dataset.mediaId || clickedMediaId;
      galleryRoot.__afGallery?.openZoomForMedia(mediaId);
    });
  }

  if (!window.__afVariantImageZoomBound) {
    window.__afVariantImageZoomBound = true;
    document.addEventListener('click', event => {
      const trigger = event.target.closest?.('[data-variant-image-zoom]');
      if (!trigger) return;
      event.preventDefault();
      event.stopPropagation();
      zoomFromVariantImage(trigger);
    }, true);
    document.addEventListener('keydown', event => {
      const trigger = event.target.closest?.('[data-variant-image-zoom]');
      if (!trigger || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      event.stopPropagation();
      zoomFromVariantImage(trigger);
    }, true);
  }

  // Keep compatibility with existing product variant scripts and older inline links.
  if (roots.length) {
    const main = roots[0];
    window.jumpTo = function(index) { main.__afGallery?.goTo('photos', index); };
    window.moveSlide = function(direction) {
      const gallery = main.__afGallery;
      if (!gallery) return;
      const active = Array.from(main.querySelectorAll('[data-gallery-switch].active'))[0]?.dataset.gallerySwitch || 'photos';
      gallery.goTo(active, (gallery.positions.get(active) || 0) + Number(direction || 0));
    };
    window.toggleMediaTab = function(type) { main.__afGallery?.show(type); };
    window.openZoom = function() { main.__afGallery?.openZoom(); };
    window.closeZoom = function() { main.__afGallery?.closeZoom(); };
  }
})();
